import { render, staticRenderFns } from "./Gerk.vue?vue&type=template&id=a01f9e00&"
import script from "./Gerk.vue?vue&type=script&lang=js&"
export * from "./Gerk.vue?vue&type=script&lang=js&"
import style0 from "./Gerk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports